import { LinearProgress as MuiLinearProgress, LinearProgressProps } from '@mui/material';

export const LinearProgress = ({ ...otherProps }: LinearProgressProps) => {
  return <MuiLinearProgress {...otherProps} />;
};
